export default __webpack_public_path__ + "static/media/DaimlerCS-Demi.5a1c6277.woff";